import React from 'react';
import Head from 'next/head';
import {
  PauseVerticalTab,
  PauseVerticalTabPanel,
  PauseVerticalTabs,
  PauseVerticalTabsList,
} from '../../components/PauseVerticalTabs';
import {
  Activity, ChevronRight,
  FileText,
  Sliders,
} from '../../../assets/icons/feather/components';
import { Integrations } from './Integrations';
import { Reports } from './components/Reports';
import { useReports } from './store';
import { useEnhancedRouter } from '../../../router';
import { Billing } from './Billing';

export const SettingsPage = ({ activeTab }: {
  activeTab: string
}) => {
  const {
    options, onDownloadReport, orgName, onDownloadLeavesRecord,
  } = useReports();
  const router = useEnhancedRouter();
  return (

    <div>
      <>
        <Head>
          <title>
            Settings | Pause
          </title>
        </Head>
        <PauseVerticalTabs
          value={activeTab}
          onChange={(tab) => {
            router.push(`/settings/${tab}`);
          }}
        >
          <div css={(theme) => ({
            display: 'grid',
            gridTemplateColumns: '250px 1fr',
            gridGap: theme.spacing(15),
          })}
          >
            <PauseVerticalTabsList>
              <PauseVerticalTab
                endIcon={<ChevronRight />}
                startIcon={<Activity />}
                value="integrations"
                label="Integrations"
              />
              <PauseVerticalTab
                endIcon={<ChevronRight />}
                startIcon={<FileText />}
                value="reports"
                label="Reports"
              />
              {process.env.NEXT_PUBLIC_FEATURE_PAYMENTS && <PauseVerticalTab endIcon={<ChevronRight />} startIcon={<Sliders />} value="billing" label="Billing" />}
            </PauseVerticalTabsList>
            <div>
              <PauseVerticalTabPanel value="integrations">
                <Integrations />
              </PauseVerticalTabPanel>
              <PauseVerticalTabPanel value="reports">
                <Reports
                  options={options}
                  onDownloadReport={onDownloadReport}
                  orgName={orgName}
                  onDownloadLeavesRecord={onDownloadLeavesRecord}
                />
              </PauseVerticalTabPanel>
              {process.env.NEXT_PUBLIC_FEATURE_PAYMENTS && (
              <PauseVerticalTabPanel value="billing">
                <Billing />
              </PauseVerticalTabPanel>
              )}
            </div>
          </div>
        </PauseVerticalTabs>
      </>
    </div>
  );
};
